import { CLIENTS } from "../api/config/config";
export const getReferralDetails = async id => {
  const {
    coreApi
  } = CLIENTS;
  const response = await coreApi.findRecord("referral", id);
  return response.data.data;
};
//# sourceMappingURL=getReferralDetails.js.map